import axios from 'helpers/axios';
import config from '../../config';

const zipApplicationsRequest = (data) => {
  const { applicationIds, projectId } = data;
  return axios({
    method: 'post',
    url: `${config.apiUrl}/applications/zip`,
    data: {
      applicationIds,
      projectId,
    }
  });
};

export default zipApplicationsRequest;
